import React, { useContext } from 'react'
import { motion } from "framer-motion";
import AboutImage from '../Assets/Images/AboutImage.jpg'
import DataContext from './Controller';

const About = () => {
    const {toggleFormVisibility} = useContext(DataContext);
    return (
        <section className="bg-white">
            <div className="gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6">
                <img className="w-full rounded-lg" src={AboutImage} alt="About" />
                <div className="mt-4 md:mt-0">
                    <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-[#1BA9F4]">About Us – The Gift That Keeps on Giving! </h2>
                    <p className="mb-6 font-normal text-gray-600 md:text-lg">At WordyGift, we make gifting simple and meaningful. For just £5, you can give a loved one 12 months of personalised motivational messages, crafted by AI to match their personality and interests.

                        No stress, no delays our gifts are instantly delivered and bring joy month after month via email or WhatsApp. The perfect last-minute gift that keeps on giving!</p>
                    <motion.button
                        className="w-[120px] h-[55px] bg-[#C8266F] text-white p-2 rounded-lg mt-5 shadow-lg hover:bg-pink-600"
                        initial={{ scale: 1 }}
                        animate={{ scale: [1, 1.1, 1] }}
                        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                        onClick={toggleFormVisibility}
                    >
                        Get Started
                    </motion.button>
                </div>
            </div>
        </section>
    )
}

export default About
